import { Component } from '@angular/core';

@Component({
  selector: 'hy-harmony',
  imports: [],
  template: ` <p>harmony works!</p> `,
  styles: ``,
})
export class DesignSystem {}
